import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Field } from "./common";

export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

const Pick = ({ label, value, onChange, options, testid }) => (
  <Field label={label}>
    <Select value={String(value)} onValueChange={onChange}>
      <SelectTrigger className="bg-white" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>{options.map(([v, l]) => <SelectItem key={v} value={String(v)}>{l}</SelectItem>)}</SelectContent>
    </Select>
  </Field>
);

export function PeriodPicker({ p, setP }) {
  const y = new Date().getFullYear();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <Pick label="Reparto" value={p.reparto} onChange={(v) => setP({ ...p, reparto: v })} options={[["Mare", "Mare"], ["Uffici", "Uffici"]]} testid="period-reparto-select" />
      <Pick label="Mese" value={p.mese} onChange={(v) => setP({ ...p, mese: Number(v) })} options={MESI.map((m, i) => [i + 1, m])} testid="period-mese-select" />
      <Pick label="Anno" value={p.anno} onChange={(v) => setP({ ...p, anno: Number(v) })} options={[y - 1, y, y + 1].map((a) => [a, a])} testid="period-anno-select" />
    </div>
  );
}

export const defaultPeriod = () => { const n = new Date(); return { reparto: "Mare", mese: n.getMonth() + 1, anno: n.getFullYear() }; };
